function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.625 2.19515L1.725 0.0951457C1.4625 -0.0798543 1.1125 0.00764573 0.85 0.182646C0.675 0.357646 0.5 0.620146 0.5 0.882646V10.5076C0.5 10.8576 0.675 11.2076 1.025 11.2951L6.625 13.7451V2.19515Z",
  fill: "#080B11"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.15 0.182328C13.8875 0.00732826 13.625 0.00732826 13.3625 0.0948283L8.375 2.19483V13.7448L13.975 11.3823C14.325 11.2073 14.5 10.9448 14.5 10.5948V0.882328C14.5 0.619828 14.325 0.357328 14.15 0.182328Z",
  fill: "#080B11"
});

const SvgTodo = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgTodo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/todo.eb1f26d4.svg";
export { ForwardRef as ReactComponent };